<script lang="ts">
    import { base } from '$app/paths';
    import Box from '$lib/components/Blocks/_wrappers/Box.svelte';
    import { getCookiePreferences, setCookiePreferences } from '$lib/helper';
    import { mediaCookiesAccepted } from '$lib/Stores/stores';

    import translations from './translations';

    import type { Language } from '$lib/types/Language';
    import type { TransitionEffect } from '$lib/types/Theme';

    export let campaignId = '';
    export let campaignVersionId = '';
    export let language: Language = 'en';
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let bgColor = 'transparent';

    const handleAccept = () => {
        const cookies = getCookiePreferences(campaignId, campaignVersionId);

        const updatedCookies = Object.assign({}, cookies);
        updatedCookies.Media = true;

        setCookiePreferences(campaignId, campaignVersionId, updatedCookies);

        $mediaCookiesAccepted = true;
    };
</script>

<Box
    top="medium"
    right="medium"
    bottom="medium"
    left="medium"
    backgroundColor={bgColor}
    narrow
    {transitionDelay}
    {transitionEffect}
>
    <div
        class="fun-mx-auto fun-max-w-md fun-rounded-lg fun-border fun-bg-white fun-p-5 fun-text-center fun-font-ui"
    >
        <p class="fun-text-sm fun-font-medium fun-text-gray-600">
            {translations[language].externalContent}
        </p>
        <p class="fun-mt-1 fun-text-sm fun-text-gray-600">
            {translations[language].bodyPreLink}<a
                href={`${base}/consent-policy`}
                class="fun-border-b fun-border-gray-400 fun-transition hover:fun-border-gray-600"
                >{translations[language].cookies}</a
            >{translations[language].bodyPostLink}
        </p>
        <button
            class="fun-mt-5 fun-w-full fun-rounded-lg fun-bg-gray-100 fun-py-2 fun-text-sm fun-font-medium fun-text-gray-600 fun-transition hover:fun-bg-gray-200"
            on:click={handleAccept}>{translations[language].accept}</button
        >
    </div>
</Box>
